export default __webpack_public_path__ + "static/media/Profile.d2d9c146.svg";